<div class="d-flex align-items-center justify-content-center implicit-sign-up-text">{{ 'GENERAL.WAIT_WHILE_LOADING_DONT_CLOSE_PAGE' | translate }}</div>
